import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CONTENT } from "@/content";
import { publicGet } from "@/lib/api";

const S = CONTENT.home.situations;

export const Situations = () => {
  const [tags, setTags] = useState([]);
  useEffect(() => { publicGet("/content").then((d) => setTags(d.tags)).catch(() => {}); }, []);
  if (!tags.length) return null;
  return (
    <section className="journey-head situations" data-testid="home-situations">
      <span className="pill">{S.label}</span>
      <h2 className="section-title">{S.title}</h2>
      <p className="story-lines">{S.text}</p>
      <div className="chips">
        {tags.map((t, i) => (
          <motion.div key={t} initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.3, delay: i * 0.06 }}>
            <Link to={`/library?tag=${encodeURIComponent(t)}`} className="share-btn situation-btn" data-testid={`home-situation-${t}`}>{t}</Link>
          </motion.div>
        ))}
      </div>
      <Link to="/library" className="text-link" data-testid="home-situations-browse">{S.browseAll} <span aria-hidden="true">→</span></Link>
    </section>
  );
};
